import axios from "axios";
import ApiUrl from "../../constant/endpoint";
import {
  RESET_PROFILE,
  // GET_PROFILE_REQUEST,
  // GET_PROFILE_SUCCESS,
  // GET_PROFILE_FAILURE,
} from "../constants/profieConstant";

import {
  UPDATE_CUSTOMER_REQUEST,
  UPDATE_CUSTOMER_FAILURE,
  UPDATE_CUSTOMER_SUCCESS,
} from "../constants/customerConstant";

// export const getProfileActionFn = (userId) => async (dispatch) => {
//   try {
//     dispatch({ type: GET_PROFILE_REQUEST });
//     const URL = `${ApiUrl.getUserProfile}?userId=${userId}`;
//     const { data } = await axios.get(URL);
//     if (data.success) {
//       dispatch({
//         type: GET_PROFILE_SUCCESS,
//         payload: data.success,
//       });
//       return data;
//     }
//   } catch (error) {
//     console.log(error.response.data);
//     console.log(error.response.status);
//     console.log(error.response.headers);
//     if (error.response.status === 500) {
//       dispatch({
//         type: GET_PROFILE_FAILURE,
//         payload: "Internal Server Error",
//       });
//     } else {
//       dispatch({
//         type: GET_PROFILE_FAILURE,
//         payload: error.response.data,
//       });
//     }
//   }
// };

export const updateCustomerProfile =
  (userId, profileDetails) => async (dispatch) => {
    // for (var pair of profileDetails.entries()) {
    //   console.log("formAppend", pair[0] + ", " + pair[1]);
    // }
    // console.log(userId);
    try {
      if (!userId) {
        throw new Error("userId is undefined");
      }
      dispatch({ type: UPDATE_CUSTOMER_REQUEST });

      const URL = `${ApiUrl.updateCustomerProfile}?userId=${userId}`;
      // const config = { withCredentials: true, credentials: "include" };

      const { data } = await axios.put(URL, profileDetails);

      console.log("axios_data", data);

      dispatch({
        type: UPDATE_CUSTOMER_SUCCESS,
        payload: data,
      });
      console.log("updated data", data);
      return data;
    } catch (error) {
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
      if (error.response.status === 500) {
        dispatch({
          type: UPDATE_CUSTOMER_FAILURE,
          payload: "Internal Server Error",
        });
      } else {
        dispatch({
          type: UPDATE_CUSTOMER_FAILURE,
          payload: error.response.data,
        });
      }
    }
  };

export const resetPROFILEAction = () => (dispatch) => {
  dispatch({ type: RESET_PROFILE });
};
